import { render, staticRenderFns } from "./avalonButtonElement.vue?vue&type=template&id=2768a9ac&scoped=true&"
import script from "./avalonButtonElement.vue?vue&type=script&lang=js&"
export * from "./avalonButtonElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768a9ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
